/**
 * CODE_COMMENTS_31
 */

export const REPORT_SELF_DIST_PUB_FIELD_ARRAY_NAME_FULL_KEGS_TO = 'selfDistPubFullKegShipmentsTo'
export const REPORT_SELF_DIST_PUB_FIELD_ARRAY_NAME_EMPTY_KEGS_FROM = 'selfDistPubEmptyKegShipmentsFrom'
